
import { Options } from "vue-class-component";
import NodesConfigMixins from "../NodesConfigMixins";

@Options({
    name: "flowable-nodes-cc-node-config",
})
export default class CcNodeConfig extends NodesConfigMixins {}
